import { Layouts } from '@/layouts'

// --------------------------------------------------------------------------
// Porte cachée vers l'aperçu de la NOUVELLE UI (refonte).
// - Adresse discrète, non devinable, reliée nulle part dans l'application.
// - Réservée par IDENTITÉ : seuls les comptes de ALLOWLIST y accèdent.
//   Tout autre utilisateur (même en tapant l'adresse) est renvoyé vers l'accueil
//   => aucun autre client ne voit qu'une bascule existe.
// - Aucune modification des écrans existants : on ajoute seulement cette route.
// --------------------------------------------------------------------------

// Comptes autorisés (e-mail de connexion, en minuscules).
// Charly + comptes invités à prévisualiser la refonte : aucun autre client ne voit la bascule.
const ALLOWLIST = [
  'charly.leggeri@limeare.com',
  'axel.fagon@limeare.com',
  'janani@horiz.io',
  // Compte interne QuentinM (236569) : ajouté pour la passe visuelle de parité
  // ancienne vs nouvelle UI (dossier le plus complet : agence + ensembles).
  // NB : ce compte n'a PAS d'email dans le jeton Keycloak -> getCurrentEmail
  // retombe sur rl_profile.username = "QuentinMi" (mis en minuscules).
  'quentinmi',
  // Client pascalducros (61068) : accord donné pour la passe de parité. Pas d'email
  // dans le jeton non plus -> identifiant = rl_profile.username "pascalducros".
  'pascalducros',
]

function getCurrentEmail() {
  const tp = (typeof window !== 'undefined' && window.keycloak && window.keycloak.tokenParsed) || null
  if (!tp) return ''

  return (tp.email || (tp.rl_profile && tp.rl_profile.username) || '').toLowerCase()
}

export const ATELIER_NEW_UI_PATH = '/atelier-7kx29'

export const atelierNewUiRoute = {
  path: ATELIER_NEW_UI_PATH,
  name: 'hz-atelier-new-ui',
  meta: {
    layout: Layouts.EMPTY,
    requireAuth: true,
    hideZendesk: true,
    noTitle: true,
  },
  component: () => import('@/views/NouvelleUiPreview.vue'),
  beforeEnter: (to, from, next) => {
    if (ALLOWLIST.includes(getCurrentEmail())) {
      next()
    } else {
      // Non autorisé : comportement identique à une adresse inexistante.
      next({ path: '/' })
    }
  },
}
